import { useTranslation } from 'react-i18next';

export default function AuroraFeaturesSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('aurora.features.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('aurora.features.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-purple-500 transition-all">
            <div className="w-16 h-16 bg-purple-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-mastercard-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.mastercard.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.mastercard.desc')}
            </p>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-blue-500 transition-all">
            <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-infinity-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.unlimited.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.unlimited.desc')}
            </p>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-green-500 transition-all">
            <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-japan-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.japan.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.japan.desc')}
            </p>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-yellow-500 transition-all">
            <div className="w-16 h-16 bg-yellow-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-bank-card-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.atm.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.atm.desc')}
            </p>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-pink-500 transition-all">
            <div className="w-16 h-16 bg-pink-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.postpaid.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.postpaid.desc')}
            </p>
          </div>

          <div className="bg-gray-800 rounded-xl p-8 border border-gray-700 hover:border-cyan-500 transition-all">
            <div className="w-16 h-16 bg-cyan-600 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-smartphone-line text-3xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-4">{t('aurora.features.app.title')}</h3>
            <p className="text-gray-300 leading-relaxed">
              {t('aurora.features.app.desc')}
            </p>
          </div>
        </div>

        {/* 注意事項 */}
        <div className="mt-12 bg-yellow-900/20 border border-yellow-700 rounded-xl p-8">
          <h3 className="text-xl font-bold text-yellow-400 mb-4 flex items-center">
            <i className="ri-alert-line text-2xl mr-3"></i>
            {t('aurora.features.notice.title')}
          </h3>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start">
              <i className="ri-arrow-right-s-line text-yellow-400 text-xl mr-2 mt-1"></i>
              <span>{t('aurora.features.notice.item1')}</span>
            </li>
            <li className="flex items-start">
              <i className="ri-arrow-right-s-line text-yellow-400 text-xl mr-2 mt-1"></i>
              <span>{t('aurora.features.notice.item2')}</span>
            </li>
            <li className="flex items-start">
              <i className="ri-arrow-right-s-line text-yellow-400 text-xl mr-2 mt-1"></i>
              <span>{t('aurora.features.notice.item3')}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}